import { render } from "./ContentUpdateScheduleComponent.vue?vue&type=template&id=bb096170&scoped=true"
import script from "./ContentUpdateScheduleComponent.vue?vue&type=script&lang=js"
export * from "./ContentUpdateScheduleComponent.vue?vue&type=script&lang=js"

import "./ContentUpdateScheduleComponent.vue?vue&type=style&index=0&id=bb096170&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb096170"]])

export default __exports__